import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_SEMESTERS, 
    ADD_NEW_SEMESTER, 
    UPDATE_SEMESTER, 
    DELETE_SEMESTER 
} from "./actionTypes";
import {
    getSemestersSuccess,
    getSemestersFail,
    addSemesterSuccess,
    addSemesterFail,
    updateSemesterSuccess,
    updateSemesterFail,
    deleteSemesterSuccess,
    deleteSemesterFail,
   
} from "./actions"

import {
    getSemesters,
    addNewSemester,
    updateSemester,
    deleteSemester,
   
} from "helpers/semesters/semesters_backend_helper";
import { toast } from "react-toastify";

function* fetchSemesters() {
    try {
        const response = yield call(getSemesters)

        yield put(getSemestersSuccess(response))
    } catch (error) {
        yield put(getSemestersFail(error))
    }
}

function* onAddNewSemester({ payload }) {
    try {

        
        const response = yield call(addNewSemester, payload)

        console.log("RESPONSE:", response);
        yield put(addSemesterSuccess(response.semester))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addSemesterFail(error))
        toast.error(error.response?.message, { autoClose: 2000 });
    }
}



function* onUpdateSemester({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateSemester, payload)
        yield put(updateSemesterSuccess(response.semester))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateSemesterFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteSemester({ payload: data }) {

    try {
        const response = yield call(deleteSemester, data)
        yield put(deleteSemesterSuccess(response.semesterId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteSemesterFail(error))
        toast.error(error.response?.message, { autoClose: 2000 });
    }
}


function* semesterSaga() {
    yield takeEvery(GET_SEMESTERS, fetchSemesters)
    yield takeEvery(ADD_NEW_SEMESTER, onAddNewSemester)
    yield takeEvery(UPDATE_SEMESTER, onUpdateSemester)
    yield takeEvery(DELETE_SEMESTER, onDeleteSemester)
}

export default semesterSaga;